webpackJsonp([106796779355985],{

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DevOpsNewy_WHITE_TALL = __webpack_require__(62);
	
	var _DevOpsNewy_WHITE_TALL2 = _interopRequireDefault(_DevOpsNewy_WHITE_TALL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConductForm = function ConductForm(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "report-conduct" },
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "three columns" },
	                _react2.default.createElement("img", { src: _DevOpsNewy_WHITE_TALL2.default, alt: "" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "nine columns main-col" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "DevOpsDays Newcastle 2018 - Report a breach"
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "form",
	                        { name: "report-conduct", method: "post", action: "/success", "data-netlify": "true", "data-netlify-honeypot": "bot-field", netlify: true },
	                        _react2.default.createElement("input", { type: "hidden", name: "bot-field" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "field" },
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "event" },
	                                "Please describe what happened / is happening."
	                            ),
	                            _react2.default.createElement("textarea", { name: "event", id: "event" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "field" },
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "suggested-outcome" },
	                                "What would you consider to be an appropriate outcome?"
	                            ),
	                            _react2.default.createElement("textarea", { name: "suggested-outcome", id: "suggested-outcome" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "field" },
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "contact-details" },
	                                "Optional: If you would like to be contacted about this, please leave some contact details such as email address or phone number."
	                            ),
	                            _react2.default.createElement("input", { type: "text", name: "contact-details", id: "contact-details" })
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "actions" },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement("input", { type: "submit", value: "Submit", className: "special" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ConductForm;
	module.exports = exports["default"];

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(53);
	
	var _Navigation = __webpack_require__(47);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ConductForm = __webpack_require__(245);
	
	var _ConductForm2 = _interopRequireDefault(_ConductForm);
	
	var _Footer = __webpack_require__(46);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportConductPage = function ReportConductPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Navigation2.default, null),
	    _react2.default.createElement(_ConductForm2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = ReportConductPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-report-conduct-js-2d9d4af5e20661da9094.js